<template>

    <div class="scene" @mouseover="mouseOverEvent" @mouseleave="mouseLeaveEvent">

        <div :class="mouseOver && flippable ? 'card is-flipped' : 'card'">

            <!-- FRONT SIZE -->
            <v-card class="d-flex card__face card__face--front justify-space-between"
                    raised
                    :style="'border-right: 7px solid ' + secondaryColor + ' !important;'"
                    :color="color"
                    :height="50">

                <div class="align-self-center d-flex">
                    <div class="ml-4 white--text subtitle-1 align-self-center font-weight-bold">
                        {{ hint }}
                    </div>
                    <v-fade-transition hide-on-leave>
                        <v-icon small class="ml-2 align-self-center" v-show="infoIconVisible && flippable">mdi-information-outline</v-icon>
                    </v-fade-transition>
                </div>

                <animated-value
                    class="mt-1 mr-2 align-self-center"
                    :value="value"
                    :prefix="prefix"
                    :prefix-icon="prefixIcon"
                    :postfix="postfix"
                    :postfix-icon="postfixIcon"
                    :key="key"
                    :animate="animate"
                    :font-size="0.75"
                ></animated-value>

            </v-card>

            <!-- BACK SIDE -->
            <v-card class="d-flex card__face card__face--back justify-space-between"
                    raised
                    :style="'border-right: 7px solid ' + mouseOverSecondaryColor + ' !important;'"
                    :color="mouseOverColor ? mouseOverColor : color"
                    :height="50">

                <div class="ml-4 white--text subtitle-1 align-self-center font-weight-bold">
                    {{ mouseOverHint }}
                </div>

                <animated-value
                    class="mt-1 mr-2 align-self-center"
                    :value="mouseOverValue"
                    :prefix="mouseOverPrefix"
                    :prefix-icon="mouseOverPrefixIcon"
                    :postfix="mouseOverPostfix"
                    :postfix-icon="mouseOverPostfixIcon"
                    :key="keyMouseOver"
                    :animate="animate"
                    :font-size="0.75"
                ></animated-value>

            </v-card>
        </div>

    </div>

</template>

<script>

import AnimatedValue from './AnimatedValue';
import {v4 as uuid} from 'uuid';

const MIN_FLIPPED_SECONDS = 0.5;

export default {

    components: {
        AnimatedValue,
    },

    props: {
        value: {
            type: Number,
            required: true,
            default: null
        },
        prefix: {
            type: String,
            required: false,
            default: ''
        },
        prefixIcon: {
            type: String,
            required: false,
            default: null,
        },
        postfix: {
            type: String,
            required: false,
            default: ''
        },
        postfixIcon: {
            type: String,
            required: false,
            default: ''
        },
        hint: {
            type: String,
            required: true,
        },
        secondaryColor: {
            type: String,
            required: false,
            default: 'primary'
        },

        mouseOverValue: {
            type: Number | null,
            required: false,
            default: null
        },
        mouseOverPrefix: {
            type: String,
            required: false,
            default: ''
        },
        mouseOverPrefixIcon: {
            type: String,
            required: false,
            default: null,
        },
        mouseOverPostfix: {
            type: String,
            required: false,
            default: ''
        },
        mouseOverPostfixIcon: {
            type: String,
            required: false,
            default: ''
        },
        mouseOverHint: {
            type: String,
            required: false
        },
        mouseOverColor: {
            type: String,
            required: false,
        },
        mouseOverSecondaryColor: {
            type: String,
            required: false,
            default: 'primary'
        },

        color: {
            type: String,
            required: false,
            default: 'primary'
        },

        animate: {
            type: Boolean,
            required: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        elevation: {
            type: Number,
            required: false,
            default: 2
        }
    },

    data() {
        return {
            mouseOver: false,
            key: null,
            keyMouseOver: null,
            infoIconVisible: true,
            timerDone: true,
            mouseLeft: false,
        }
    },

    mounted() {
        this.key = uuid();
        this.keyMouseOver = uuid();
    },

    methods: {

        mouseOverEvent() {
            this.timerDone = false;

            setTimeout(() => {
                this.timerDone = true;
                if (this.mouseLeft) {
                    this.mouseLeft = false;
                    this.mouseLeaveEvent();
                }
            }, MIN_FLIPPED_SECONDS * 1000);

            this.mouseOver = true;
            this.infoIconVisible = false;
        },

        mouseLeaveEvent() {
            if (this.timerDone) {
                this.mouseOver = false;
                setTimeout(() => {
                    this.infoIconVisible = true;
                }, 400);
            } else {
                this.mouseLeft = true;
            }
        }
    },

    computed: {

        showPrimary() {
            return this.mouseOver === false || this.mouseOverValue === null
        },

        flippable() {
            return this.mouseOverValue !== null;
        }
    },
}
</script>

<style scoped>

.scene {
    height: 50px;
    perspective: 600px;
}

.info-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 100;
}

.card {
    width: 100%;
    height: 50px;
    transition: transform 0.5s;
    transform-style: preserve-3d;
}

.card.is-flipped {
    transform: rotateX(180deg);
}

.card__face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
}

.card__face--front {
}

.card__face--back {
    transform: rotateX(180deg);
}


</style>
